/**
 * Fichier de configuration de i18next, gestionnaire de traductions
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '@/lang/en.json';
import frTranslations from '@/lang/fr.json';

const resources = {
    en: {
        translation: enTranslations
    },
    fr: {
        translation: frTranslations
    }
};

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        fallbackLng: "en",
        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupQuerystring: 'lang'
        },
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
